export default {
  tab: '反馈',
  toolbar: {
    markup: '标注',
    record: '录屏',
    hint: '点击标注，拖动绘制',
    hintTouch: '用手指圈出问题',
    hintRecord: '正在录制屏幕',
    exit: '退出',
  },
  popup: {
    about: '关于',
    placeholder: '描述问题或建议...',
    submit: '提交',
    sending: '发送中...',
    cancel: '取消',
    close: '关闭',
    my_feedback: '我的反馈',
    screenshot_label: '附带页面截图',
    screenshot_hint: '密码等敏感字段会自动打码。',
    screenshot_short: '截图',
    screenshot_locked_hint: '圈画会画在截图上，所以必定附带。敏感字段会自动打码。',
    recording_label: '录制',
    recording_locked_hint: '页面画面与操作过程的回放，录制内容必定随反馈提交。不含摄像头和麦克风，敏感字段会自动打码。',
    quickOptions: [
      { emoji: '🐛', label: '出错', value: '出问题了' },
      { emoji: '💡', label: '建议', value: '我有一个建议' },
      { emoji: '🤔', label: '疑问', value: '我有点疑问' },
    ],
  },
  success: {
    title: '收到了，谢谢你的反馈。',
    title_no_ai: '感谢！我们已收到您的反馈。',
    close: '关闭',
    email_saved: '问题解决后您会收到邮件通知。',
    email_error: '邮箱保存失败，请重试。',
    track_feedback: '查看处理进度',
    email_cta: '解决后邮件通知我',
    notify: '通知我',
  },
  error: {
    submit: '提交失败，请重试。',
    finalize_title: '暂时无法发送。',
    finalize_message: '你的反馈仍已保存，请重试。',
  },
  pet: {
    bubble: '需要帮助吗？',
  },
  frustration: {
    prompt: '遇到问题了？告诉我们。',
    action: '标注',
    dismiss: '关闭',
  },
  annotation: {
    drawing: '绘制',
    element: '元素',
  },
  draw: {
    note_placeholder: '给你的绘制添加说明',
    undo: '撤销',
    redo: '重做',
    cancel: '取消',
    submit: '提交',
  },
  record: {
    stop: '停止',
    timer_label: '录制中',
    max_reached: '已达到最长录制时间',
    replay_label: 'screen-recording.json',
    play: '播放录屏',
    close: '关闭',
    preview_unavailable: '暂无法预览',
  },
  clarify: {
    title: 'Make This Better AI',
    subtitle: '正在完善你的反馈',
    thinking: '思考中...',
    placeholder: '补充说明后提交',
    send: '发送',
    submit: '提交',
    send_feedback: '发送反馈',
    skip: '跳过并提交',
    skip_short: '跳过',
    cancel: '取消并不发送',
    retry: '重试',
    error: '追问加载失败，可以直接发送反馈。',
    expired: '这条反馈在发送前已过期。请关闭组件后重新提交。',
  },
}
